import { UserChatStatus } from '@/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';
export class User {
    public userId: number = 0;
    public crosscheckId: number = 0;
    public username: string = '';
    public lastLogin: string = '';
    public password: string = '';
    public userChatStatus: UserChatStatus = UserChatStatus.ChatModerator;
    public cleansedAlertWords: string[] = [];
    public autoRestoreAllWindows: boolean;
    public jwt: string = '';
    public isCsMember: boolean = false;
    public adroles: string[];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/user/index.ts